import countryListAvailableForKlarna from 'lib/constant/countryListAvailableForKlarna';
import PropTypes from 'prop-types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './Modal.module.scss';
import crossIcon from '../../../assets/cross.svg';
const ModalKlarna = (
    {
        amount,
        currency,
        userForm,
        userFormError,
        setUserFormError,
        setUserForm,
        initialUserFormState,
        openModal,
        setOpenModal,
        isFormCompleted,
        setHasClickedKlarna,
        mustRecreateDropin,
        isLoading,
    },
) => {
    const { t } = useTranslation();
    const [countriesListOptions] = React.useState(() => countryListAvailableForKlarna.filter((elem) => elem.currency === currency)
        .map((elem) => {
            return {
                value: elem.value, text: t(`country.${elem.value}`),
            };
        }));

    const handleChange = (phoneNumber) => {
        // Ensure the input always starts with '+'
        if (phoneNumber === '' || phoneNumber === '+') {
            setUserForm({ ...userForm, phone_number: '+' });
        } else if (phoneNumber.startsWith('+')) {
            setUserForm({ ...userForm, phone_number: phoneNumber });
        } else {
            setUserForm({ ...userForm, phone_number: '+' + phoneNumber });
        }
    };

    const resetModal = () => {
        setUserForm(initialUserFormState);
        setOpenModal(false);
        setUserFormError();
        mustRecreateDropin.current = true;
    };

    const isCountryListASingleElement = React.useMemo(() => {
        return countriesListOptions.length === 1;
    }, [countriesListOptions]);

    React.useEffect(() => {
        if (isCountryListASingleElement && !userForm.country) {
            setUserForm({ ...userForm, country: countriesListOptions[0].value });
        }
    }, [isCountryListASingleElement, setUserForm, userForm, countriesListOptions]);

    // Add a class to body to display the modal
    React.useEffect(() => {
        const root = document.body;
        if (openModal) {
            root.classList.add(styles.modal_open);
        } else {
            root.classList.remove(styles.modal_open);
        }

        return () => {
            // unmount
            root.classList.remove(styles.modal_open);
        };
    }, [openModal]);

    if (!openModal) {
        return null;
    }

    return (
        <div className={styles.container_modal}>
            <div className={styles.scroll}>
                <div className={styles.modal}>

                    <div className={styles.title}>
                        {t('pay_with_klarna')}
                        <img className={styles.icon}
                            alt='cross for cancel'
                            onClick={() => {
                                resetModal();
                            }} src={crossIcon}>
                        </img>
                    </div>

                    <div className={styles.modal_subtitle}>
                        {t('split_payment_klarna',
                            {
                                amount: (amount / 300).toFixed(2),
                                currency: currency,
                            })
                        }
                    </div>
                    <div className={styles.scroll}>
                        {userForm.country === '' ? (
                            <div className={styles.container_row_input}>
                                <div className={styles.container_input}>
                                    <label>{t('klarna_form_country')}</label>
                                    <select
                                        defaultValue={''}
                                        className={styles.input}
                                        value={userForm.country}
                                        onChange={(e) => {
                                            setUserForm({ ...userForm, country: e.target.value });
                                        }}>
                                        <option className={styles.select} />
                                        <option value={''}>  -- Select your residence country -- </option>
                                        {countriesListOptions.map(country => (
                                            <option key={country.value} value={country.value}>{country.text}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        ) : (
                            <>
                                <div className={styles.container_row_input}>
                                    <div className={styles.container_input}>
                                        <label> {t('international_bank_lastName')}</label>
                                        <input
                                            className={styles.input}
                                            value={userForm.last_name}
                                            onChange={(e) => {
                                                setUserForm({ ...userForm, last_name: e.target.value });
                                            }}
                                            placeholder={t('klarna_name_placeholder')} />
                                    </div>
                                    <div className={styles.container_input}>
                                        <label> {t('international_bank_firstName')}</label>
                                        <input
                                            className={styles.input}
                                            value={userForm.first_name}
                                            onChange={(e) => {
                                                setUserForm({ ...userForm, first_name: e.target.value });
                                            }}
                                            placeholder={t('klarna_firstname_placeholder')} />
                                    </div>
                                </div >

                                <div className={styles.container_row_input}>
                                    <div className={styles.container_input}>
                                        <label>{t('klarna_form_phone_number')}</label>
                                        <input
                                            className={styles.input}
                                            value={userForm.phone_number}
                                            onChange={(e) => {
                                                handleChange(e.target.value);
                                            }}
                                            onKeyDown={(event) => {
                                                if (!/[\d()]/.test(event.key) && event.key !== 'Backspace') {
                                                    event.preventDefault();
                                                }
                                            }}
                                            placeholder={t('klarna_form_phone_number_placeholder')}
                                        />
                                    </div>
                                </div>
                                {userFormError && (<p className={styles.input_error_message}>{t('klarna_form_phone_number_invalid')}</p>)}

                                <div className='wz-lyriapay__modal-title'>
                                    {t('klarna_form_billing_address')}
                                </div>

                                <div className={styles.container_row_input}>
                                    <div className={styles.container_input}>
                                        <label>{t('klarna_form_street_number')}</label>
                                        <input
                                            className={styles.input}
                                            value={userForm.street_number}
                                            onChange={(e) => {
                                                setUserForm({ ...userForm, street_number: e.target.value });
                                            }}
                                            placeholder={t('klarna_street_address_placeholder')} />
                                    </div>
                                    <div className={styles.container_input}>
                                        <label>{t('international_bank_address')}</label>
                                        <input
                                            className={styles.input}
                                            value={userForm.street}
                                            onChange={(e) => {
                                                setUserForm({ ...userForm, street: e.target.value });
                                            }}
                                            placeholder={t('klarna_address_placeholder')} />
                                    </div>
                                </div>

                                <div className={styles.container_row_input}>
                                    <div className={styles.container_input}>
                                        <label> {t('international_bank_zipcode')}</label>
                                        <input
                                            className={styles.input}
                                            value={userForm.zip_code}
                                            onChange={(e) => {
                                                setUserForm({ ...userForm, zip_code: e.target.value });
                                            }}
                                            placeholder={t('klarna_zipcode_placeholder')} />
                                    </div>
                                    <div className={styles.container_input}>
                                        <label> {t('international_bank_city')}</label>
                                        <input
                                            className={styles.input}
                                            value={userForm.city}
                                            onChange={(e) => {
                                                setUserForm({ ...userForm, city: e.target.value });
                                            }}
                                            placeholder={t('klarna_city_placeholder')} />
                                    </div>
                                </div>

                                <div className={styles.container_row_input}>
                                    <div className={styles.container_input}>
                                        <label>{t('international_bank_region')}</label>
                                        <input
                                            className={styles.input}
                                            value={userForm.region}
                                            onChange={(e) => {
                                                setUserForm({ ...userForm, region: e.target.value });
                                            }} />
                                    </div>
                                    <div className={styles.container_input}>
                                        <label>{t('klarna_form_country')}</label>
                                        <select
                                            defaultValue={''}
                                            className={styles.input}
                                            disabled={isCountryListASingleElement}
                                            value={userForm.country}
                                            onChange={(e) => {
                                                setUserForm({ ...userForm, country: e.target.value });
                                            }}>
                                            <option className={styles.select} />
                                            <option value={''}>  -- Select your residence country -- </option>
                                            {countriesListOptions.map(country => (
                                                <option key={country.value} value={country.value}>{country.text}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </>
                        )}

                        <p className={styles.footer}>
                            <Trans i18nKey='klarna_form_footer'>
                                Before the link
                                <a target='_blank' rel='noreferrer' className={styles.footer_link}
                                    href={`https://cdn.klarna.com/1.0/shared/content/legal/terms/fr-FR/paylaterin3`}>
                                    link text
                                </a>
                            </Trans>
                        </p>
                    </div>

                    <div className={styles.container_button}>
                        <button
                            disabled={!isFormCompleted || isLoading}
                            onClick={() => {
                                if (isFormCompleted && !isLoading) {
                                    setHasClickedKlarna(true);
                                }
                            }}
                            className={isFormCompleted && !isLoading ? `${styles.button_validate} ${styles.button}` : `${styles.button_validate_disabled} ${styles.button}`}
                        >
                            {t('klarna_form_continue_with_klarna')}
                        </button>
                        <button
                            onClick={() => {
                                resetModal();
                            }}
                            className={styles.button}
                        >
                            {t('klarna_form_cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

ModalKlarna.propTypes = {
    amount: PropTypes.number,
    currency: PropTypes.string,
    userForm: PropTypes.object,
    userFormError: PropTypes.string,
    setUserFormError: PropTypes.func,
    setUserForm: PropTypes.func,
    initialUserFormState: PropTypes.object,
    phoneCountryCode: PropTypes.string,
    setPhoneCountryCode: PropTypes.func,
    openModal: PropTypes.bool,
    setOpenModal: PropTypes.func,
    isFormCompleted: PropTypes.bool,
    setHasClickedKlarna: PropTypes.func,
    mustRecreateDropin: PropTypes.object,
    isLoading: PropTypes.bool,
};

export default ModalKlarna;
